module.exports = __webpack_public_path__ + "img/book.b40767c7.svg";